<div
  class="multiselect-container"
  [class.open]="isDropdownOpen"
  [ngClass]="styleClass"
  (click)="toggleDropdown()"
  (keydown.enter)="toggleDropdown()"
  tabindex="0"
  [class.disabled]="isDisabled"
  id="tour-multiselect-filter"
>
  <div class="selected-display">
    @if (filteredSelectedValues.length === 0) {
      <span class="placeholder-text">{{ placeholder }}</span>
    } @else if (filteredSelectedValues.length <= 2) {
      @for (val of filteredSelectedValues; track val) {
        <span class="tag">
          {{ getOptionLabel(val) }}
          <span
            class="tag-remove"
            (click)="removeTag(val, $event)"
            (keydown)="removeTag(val, $event)"
            tabindex="0"
            >&#x2715;</span
          >
        </span>
      }
    } @else {
      <span class="tag">{{ filteredSelectedValues.length }} selected</span>
    }
  </div>

  <div class="icon-container">
    <svg
      class="chevron"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6 8L10 12L14 8"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</div>

@if (isDropdownOpen) {
  <div class="dropdown-container" (appClickOutside)="onClickOutside()">
    <div class="top-row">
      @if (filteredOptions.length !== 0) {
        <label class="checkbox-container">
          <input
            type="checkbox"
            [checked]="filteredSelectedValues.length === filteredOptions.length"
            (change)="onSelectAll()"
            [disabled]="options.length === 0"
          />
          <span class="checkmark"></span>
        </label>
      }

      <div class="search-wrapper">
        <svg
          class="search-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14 14L18 18M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <input
          type="text"
          placeholder="Search..."
          [(ngModel)]="searchValue"
          (input)="onSearch(searchValue)"
        />
      </div>
    </div>

    <div class="options-list">
      @if (filteredOptions.length === 0) {
        <div class="empty-state">
          {{ searchValue ? "No results found" : "No options available" }}
        </div>
      } @else {
        @for (option of filteredOptions; track option[valueKey]) {
          <label
            class="option-item"
            [class.selected]="filteredSelectedValues.includes(option[valueKey])"
          >
            <input
              type="checkbox"
              [checked]="filteredSelectedValues.includes(option[valueKey])"
              (change)="onSelectOption(option[valueKey])"
            />
            <span class="checkmark"></span>
            <span class="option-text">
              {{
                fallBackLabel
                  ? option[optionKey]
                    ? option[optionKey]
                    : option[valueKey]
                  : option[optionKey]
              }}
            </span>
          </label>
        }
      }
    </div>

    @if (filteredOptions.length !== 0) {
      <div class="footer">
        <button type="button" (click)="onClear()">Clear</button>
        <button type="button" (click)="onApply()">Apply</button>
      </div>
    }
  </div>
}
